import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { PhArrowRight } from 'ember-phosphor-icons';
import Card from 'tio-ui/components/card';
import Heading from 'tio-ui/components/heading';
import Text from 'tio-ui/components/text';

interface ProgramCardSignature {
  Args: {
    /** Program name, rendered as the card's h3. */
    title: string;
    /** Clamped to two lines; omitted when empty. */
    description?: string | null;
    /** Route the footer link opens. */
    route: string;
    /** Model for `@route`. */
    model: string;
    /** Footer link text, e.g. "See more". */
    linkLabel: string;
  };
  Blocks: {
    /** Status chips, right-aligned above the title. */
    chips?: [];
  };
  Element: HTMLDivElement;
}

/** Benefit-program summary card for a program grid. */
const ProgramCard: TOC<ProgramCardSignature> = <template>
  <Card @padding="sm" @radius="nested" class="tio-col tio-elevation-card-hover" ...attributes>
    <div class="tio-flex-end gap-2 min-h-5">
      {{yield to="chips"}}
    </div>
    <div class="tio-col-extra-tight">
      <Heading @level={{3}} @size="base">{{@title}}</Heading>
      {{#if @description}}
        <Text @variant="muted" @size="sm" class="line-clamp-2">
          {{@description}}
        </Text>
      {{/if}}
    </div>
    <div>
      <LinkTo @route={{@route}} @model={{@model}} class="tio-text-sm-semibold app-text-link">
        {{@linkLabel}}
        <PhArrowRight class="tio-icon-xs ml-1 inline" />
      </LinkTo>
    </div>
  </Card>
</template>;

export default ProgramCard;
